/* ============================================================
   Lion Card — About v2
   v1.1.0 — ambient FX system
   - Fade-up reveals on scroll (IntersectionObserver)
   - Particle generation (dust mode only) — aurora/mist/rays are pure CSS
   - Speed-aware duration scaling
   - Respects prefers-reduced-motion
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal-on-scroll ------------------------------------------ */
  function initReveals() {
    var els = document.querySelectorAll('.lc-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Particle field (dust mode only) --------------------------- */
  function initParticles() {
    if (reduce) return;
    var fields = document.querySelectorAll('[data-lc-fx-style="dust"]');
    fields.forEach(function (field) {
      var count = parseInt(field.getAttribute('data-lc-fx-count'), 10) || 10;
      var speed = parseFloat(field.getAttribute('data-lc-fx-speed')) || 5;

      // Speed → animation duration. Speed 1 (slow) ≈ 16s · Speed 5 (default) ≈ 10s · Speed 10 (fast) ≈ 3s
      var baseDur = Math.max(3, 18 - speed * 1.5);

      for (var i = 0; i < count; i++) {
        var p = document.createElement('span');
        p.className = 'lc-particle';
        p.style.left = (Math.random() * 96 + 2) + '%';
        p.style.animationDelay = (Math.random() * baseDur).toFixed(2) + 's';
        // Per-particle randomization on top of base duration for organic feel
        p.style.animationDuration = (baseDur * (0.8 + Math.random() * 0.5)).toFixed(2) + 's';
        var size = (1 + Math.random() * 2.5).toFixed(1);
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        field.appendChild(p);
      }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initReveals();
    initParticles();
  });
})();